import { Component } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-criador-assinatura',
  templateUrl: './criador-assinatura.html',
  standalone: false,
})
export class CriadorAssinaturaComponent {
  name: string = '';
  cargo: string = '';
  phone: string = '';
  mail: string = '';

  codigo: string = '';

  constructor(private authorizeService: AuthService) {
    this.name = this.authorizeService.getUser()?.nome || '';
    this.mail = this.authorizeService.getUser()?.email || '';
    this.cargo = this.authorizeService.getUser()?.cargo || '';
    this.phone = this.authorizeService.getUser()?.telefone || '';
  }
}
